export const DPDPA_DOMAINS = [
  { key: "Consent & Notice", title: "Consent & Notice", controlCount: 12 },
  { key: "Data Principal Rights", title: "Data Principal Rights", controlCount: 10 },
  { key: "Data Processing", title: "Data Processing Governance", controlCount: 9 },
  { key: "Data Security", title: "Data Security Safeguards", controlCount: 11 },
  { key: "Breach Mgmt", title: "Breach Management", controlCount: 8 },
  { key: "Children's Data", title: "Children's Data", controlCount: 8 },
  { key: "Cross-Border", title: "Cross-Border Transfer", controlCount: 7 },
  { key: "Significant DF", title: "Significant DF Obligations", controlCount: 10 },
  { key: "Vendor/Processor", title: "Vendor & Processor Mgmt", controlCount: 6 },
  { key: "Accountability", title: "Accountability & Audit", controlCount: 7 },
];

export const DPDPA_CONTROLS = [
  {
    controlId: "DPDPA-CON-01",
    domain: "Consent & Notice",
    dpdpaSection: "S.6",
    controlRequirement: "Obtain valid consent before processing",
    implementationStandard:
      "Consent must be free, specific, informed, unconditional, unambiguous with clear affirmative action",
    evidence: "Consent records, UI screenshots, Logs",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "OneTrust, TrustArc, Securiti",
    auditMethod: "Consent record sampling",
    commonGaps: "Bundled consent; Pre-ticked boxes",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-02",
    domain: "Consent & Notice",
    dpdpaSection: "S.5",
    controlRequirement: "Provide notice at time of collection",
    implementationStandard:
      "Itemized notice with data description, purpose, rights, grievance process, cross-border details",
    evidence: "Notice templates, UI implementation",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Consent Management Platform",
    auditMethod: "Notice review",
    commonGaps: "Notice buried in T&C",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-03",
    domain: "Consent & Notice",
    dpdpaSection: "S.6(4)",
    controlRequirement: "Enable withdrawal of consent",
    implementationStandard:
      "Easy mechanism as simple as giving consent with consequences explanation",
    evidence: "Withdrawal UI, Process docs, Logs",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Consent Platform, Self-service",
    auditMethod: "Withdrawal flow testing",
    commonGaps: "Difficult withdrawal",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-04",
    domain: "Consent & Notice",
    dpdpaSection: "S.6(7)",
    controlRequirement: "Maintain proof of consent",
    implementationStandard:
      "Verifiable record with timestamp, version, scope, method",
    evidence: "Consent database, Audit trail",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Consent Management Platform",
    auditMethod: "Audit trail review",
    commonGaps: "No audit trail",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-05",
    domain: "Consent & Notice",
    dpdpaSection: "S.7",
    controlRequirement: "Document legitimate use basis",
    implementationStandard:
      "Document legitimate use for each processing activity per S.7 categories",
    evidence: "Legitimate use register",
    owner: "DPO/Legal",
    frequency: "Per activity",
    technologyEnablers: "Data Catalog, Privacy Mgmt",
    auditMethod: "Register review",
    commonGaps: "No documentation",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CON-06",
    domain: "Consent & Notice",
    dpdpaSection: "S.5(2)",
    controlRequirement: "Notice in English and scheduled languages",
    implementationStandard:
      "Notice in English and Schedule VIII languages per user preference",
    evidence: "Multi-language notices",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Translation Mgmt",
    auditMethod: "Language coverage check",
    commonGaps: "English only",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CON-07",
    domain: "Consent & Notice",
    dpdpaSection: "S.6",
    controlRequirement: "Granular consent for different purposes",
    implementationStandard:
      "Separate consent for distinct purposes; no bundling",
    evidence: "Consent UI with separation",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Consent Platform",
    auditMethod: "UI review",
    commonGaps: "Single bundled consent",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-08",
    domain: "Consent & Notice",
    dpdpaSection: "S.6(5)",
    controlRequirement: "Re-obtain consent for new purposes",
    implementationStandard:
      "Fresh consent before processing for new purposes",
    evidence: "Consent refresh mechanism",
    owner: "DPO",
    frequency: "Per change",
    technologyEnablers: "Consent Platform",
    auditMethod: "Change-to-consent mapping",
    commonGaps: "Silent purpose expansion",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-09",
    domain: "Consent & Notice",
    dpdpaSection: "S.9",
    controlRequirement: "Register with Consent Manager (if used)",
    implementationStandard:
      "If using Consent Manager, ensure registration compliance",
    evidence: "Agreement, Integration docs",
    owner: "DPO",
    frequency: "Per engagement",
    technologyEnablers: "Consent Manager",
    auditMethod: "Contract review",
    commonGaps: "Unregistered Manager",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CON-10",
    domain: "Consent & Notice",
    dpdpaSection: "S.5",
    controlRequirement: "Include cross-border transfer info",
    implementationStandard:
      "Notice must specify transfer outside India and countries",
    evidence: "Transfer notice, Country list",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Data Flow Mapping",
    auditMethod: "Notice verification",
    commonGaps: "No transfer disclosure",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CON-11",
    domain: "Consent & Notice",
    dpdpaSection: "S.6",
    controlRequirement: "Age-appropriate consent mechanisms",
    implementationStandard:
      "Different flows for adults vs children with parental verification",
    evidence: "Age gate, Parental consent",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Age Verification",
    auditMethod: "Flow testing",
    commonGaps: "No age verification",
    penaltyRisk: "₹200 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CON-12",
    domain: "Consent & Notice",
    dpdpaSection: "S.5",
    controlRequirement: "Provide DPO contact in notice",
    implementationStandard:
      "Notice must include DPO contact details",
    evidence: "Notice templates",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Privacy Center",
    auditMethod: "Template review",
    commonGaps: "Missing DPO contact",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },

  {
    controlId: "DPDPA-DPR-01",
    domain: "Data Principal Rights",
    dpdpaSection: "S.11(1)",
    controlRequirement: "Right to access and information",
    implementationStandard:
      "Provide summary of personal data and processing activities upon request",
    evidence: "Access portal, Data summary",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Automation (OneTrust, Forcepoint)",
    auditMethod: "DSAR fulfillment sampling",
    commonGaps: "Manual process; Incomplete",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPR-02",
    domain: "Data Principal Rights",
    dpdpaSection: "S.12(1)",
    controlRequirement: "Right to correction",
    implementationStandard:
      "Enable correction with propagation to processors",
    evidence: "Correction portal, Workflow",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Automation, MDM",
    auditMethod: "Propagation verification",
    commonGaps: "No processor propagation",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPR-03",
    domain: "Data Principal Rights",
    dpdpaSection: "S.12(2)",
    controlRequirement: "Right to erasure",
    implementationStandard:
      "Erase when no longer necessary or consent withdrawn",
    evidence: "Erasure portal, Deletion workflow",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Automation, Lifecycle",
    auditMethod: "Deletion sampling",
    commonGaps: "Incomplete erasure",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPR-04",
    domain: "Data Principal Rights",
    dpdpaSection: "S.13",
    controlRequirement: "Right to grievance redressal",
    implementationStandard:
      "Grievance mechanism with response within 30 days",
    evidence: "Grievance portal, SLA tracking",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "Case Management",
    auditMethod: "SLA tracking review",
    commonGaps: "Slow response",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPR-05",
    domain: "Data Principal Rights",
    dpdpaSection: "S.14",
    controlRequirement: "Right to nominate",
    implementationStandard:
      "Enable nomination for rights in case of death/incapacity",
    evidence: "Nomination mechanism",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Platform",
    auditMethod: "Feature verification",
    commonGaps: "No nomination facility",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPR-06",
    domain: "Data Principal Rights",
    dpdpaSection: "S.11-14",
    controlRequirement: "Response timeline",
    implementationStandard: "Respond within 30 days (extendable)",
    evidence: "SLA reports, Response logs",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Automation",
    auditMethod: "SLA compliance review",
    commonGaps: "Timeline breaches",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPR-07",
    domain: "Data Principal Rights",
    dpdpaSection: "S.11",
    controlRequirement: "Provide processing information",
    implementationStandard:
      "Inform about purposes, categories, retention, recipients",
    evidence: "Data summary template",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "Data Catalog, DSAR",
    auditMethod: "Response template review",
    commonGaps: "Incomplete disclosure",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPR-08",
    domain: "Data Principal Rights",
    dpdpaSection: "S.15",
    controlRequirement: "Verify Data Principal identity",
    implementationStandard:
      "Verify identity before honoring requests",
    evidence: "Identity verification",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "Identity Verification",
    auditMethod: "Verification process test",
    commonGaps: "No verification",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPR-09",
    domain: "Data Principal Rights",
    dpdpaSection: "S.11-14",
    controlRequirement: "No fee for first request",
    implementationStandard:
      "First copy free; fee only for excessive requests",
    evidence: "Fee policy, Tracking",
    owner: "DPO",
    frequency: "Per request",
    technologyEnablers: "DSAR Platform",
    auditMethod: "Policy review",
    commonGaps: "Charging for first",
    penaltyRisk: "₹10 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-DPR-10",
    domain: "Data Principal Rights",
    dpdpaSection: "S.13",
    controlRequirement: "Inform of DPBI escalation",
    implementationStandard:
      "Inform of right to escalate to DPBI",
    evidence: "Response templates",
    owner: "DPO",
    frequency: "Per grievance",
    technologyEnablers: "Case Management",
    auditMethod: "Template review",
    commonGaps: "No escalation info",
    penaltyRisk: "₹10 Cr",
    automation: "Low",
  },

  {
    controlId: "DPDPA-DPG-01",
    domain: "Data Processing",
    dpdpaSection: "S.4",
    controlRequirement: "Process only for lawful purposes",
    implementationStandard:
      "Document lawful basis for each processing activity",
    evidence: "Processing register",
    owner: "DPO",
    frequency: "Per activity",
    technologyEnablers: "Data Catalog, Privacy Mgmt",
    auditMethod: "Register review",
    commonGaps: "Undocumented processing",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPG-02",
    domain: "Data Processing",
    dpdpaSection: "S.4",
    controlRequirement: "Purpose limitation",
    implementationStandard:
      "Process only for purposes in notice or legitimate use",
    evidence: "Purpose register",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Data Catalog, DLP",
    auditMethod: "Purpose mapping review",
    commonGaps: "Purpose creep",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPG-03",
    domain: "Data Processing",
    dpdpaSection: "S.4",
    controlRequirement: "Data minimization",
    implementationStandard: "Collect only necessary data",
    evidence: "Data inventory, Review",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Data Discovery",
    auditMethod: "Inventory review",
    commonGaps: "Over-collection",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPG-04",
    domain: "Data Processing",
    dpdpaSection: "S.8(3)",
    controlRequirement: "Data accuracy",
    implementationStandard:
      "Ensure data is accurate and up-to-date",
    evidence: "Data quality checks",
    owner: "Data Owner",
    frequency: "Continuous",
    technologyEnablers: "Data Quality, MDM",
    auditMethod: "Quality control review",
    commonGaps: "Stale data",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPG-05",
    domain: "Data Processing",
    dpdpaSection: "S.8(7)",
    controlRequirement: "Storage limitation",
    implementationStandard:
      "Retain only for necessary period; erase when done",
    evidence: "Retention schedule",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Data Lifecycle Mgmt",
    auditMethod: "Retention validation",
    commonGaps: "Indefinite retention",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-DPG-06",
    domain: "Data Processing",
    dpdpaSection: "S.4",
    controlRequirement: "Records of Processing (ROPA)",
    implementationStandard:
      "Maintain comprehensive processing records",
    evidence: "ROPA register",
    owner: "DPO",
    frequency: "Quarterly",
    technologyEnablers: "Data Catalog, Privacy Mgmt",
    auditMethod: "ROPA completeness review",
    commonGaps: "Incomplete ROPA",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPG-07",
    domain: "Data Processing",
    dpdpaSection: "S.7",
    controlRequirement: "Voluntary provision processing",
    implementationStandard:
      "Process voluntary data only for specified purpose",
    evidence: "Voluntary flagging",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Consent Platform",
    auditMethod: "Workflow review",
    commonGaps: "No distinction",
    penaltyRisk: "₹10 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-DPG-08",
    domain: "Data Processing",
    dpdpaSection: "S.17(5)",
    controlRequirement: "Government exemption documentation",
    implementationStandard:
      "Document exemption basis and proportionality",
    evidence: "Exemption register",
    owner: "Legal/DPO",
    frequency: "Per activity",
    technologyEnablers: "Privacy Management",
    auditMethod: "Register review",
    commonGaps: "Overuse of exemptions",
    penaltyRisk: "₹50 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-DPG-09",
    domain: "Data Processing",
    dpdpaSection: "S.8",
    controlRequirement: "Technical and org measures",
    implementationStandard:
      "Implement appropriate measures for compliance",
    evidence: "Control documentation",
    owner: "CISO/DPO",
    frequency: "Continuous",
    technologyEnablers: "Privacy Tech Stack",
    auditMethod: "Control review",
    commonGaps: "Insufficient measures",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },

  {
    controlId: "DPDPA-SEC-01",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Reasonable security safeguards",
    implementationStandard:
      "Implement reasonable safeguards to prevent breach",
    evidence: "Security architecture",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "Comprehensive security stack",
    auditMethod: "Architecture review",
    commonGaps: "Inadequate security",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-02",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Encryption at rest",
    implementationStandard:
      "Encrypt all personal data at rest (AES-256)",
    evidence: "Encryption policy, Config",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "TDE, FDE, HSM",
    auditMethod: "Encryption testing",
    commonGaps: "Partial encryption",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-03",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Encryption in transit",
    implementationStandard: "Encrypt all data in transit (TLS 1.2+)",
    evidence: "TLS config, Certs",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "PKI, TLS",
    auditMethod: "TLS scan",
    commonGaps: "TLS 1.0/1.1",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-04",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Access control",
    implementationStandard: "Role-based access with least privilege",
    evidence: "Access matrix, RBAC",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "IAM, PAM",
    auditMethod: "Access sampling",
    commonGaps: "Excessive access",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-05",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Pseudonymization",
    implementationStandard:
      "Pseudonymize where possible to reduce breach impact",
    evidence: "Policy, Implementation",
    owner: "CISO/DPO",
    frequency: "Per dataset",
    technologyEnablers: "Data Masking, Tokenization",
    auditMethod: "Implementation review",
    commonGaps: "No pseudonymization",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-06",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Access logging",
    implementationStandard: "Log all access to personal data systems",
    evidence: "Log config, SIEM",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "SIEM, DAM",
    auditMethod: "Log coverage audit",
    commonGaps: "Incomplete logging",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-07",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Vulnerability management",
    implementationStandard:
      "Regular VA and patching for personal data systems",
    evidence: "VA reports, Patch status",
    owner: "CISO",
    frequency: "Quarterly",
    technologyEnablers: "VA tools",
    auditMethod: "VA scope review",
    commonGaps: "Unpatched systems",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-08",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Data Loss Prevention",
    implementationStandard: "DLP to prevent unauthorized exfiltration",
    evidence: "DLP policy, Config",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "DLP (Symantec, Forcepoint)",
    auditMethod: "DLP testing",
    commonGaps: "Partial coverage",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-09",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Backup encryption",
    implementationStandard:
      "Encrypt backups with separate key management",
    evidence: "Backup encryption config",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "Backup tools, HSM",
    auditMethod: "Backup audit",
    commonGaps: "Unencrypted backups",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SEC-10",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Secure disposal",
    implementationStandard:
      "Securely erase data using approved methods",
    evidence: "Disposal procedure, Certs",
    owner: "CISO/DPO",
    frequency: "Per disposal",
    technologyEnablers: "Secure Deletion tools",
    auditMethod: "Disposal records review",
    commonGaps: "Insecure disposal",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-SEC-11",
    domain: "Data Security",
    dpdpaSection: "S.8(4)",
    controlRequirement: "Security testing",
    implementationStandard:
      "Regular penetration testing of personal data systems",
    evidence: "PT reports",
    owner: "CISO",
    frequency: "Annual",
    technologyEnablers: "PT services",
    auditMethod: "PT report review",
    commonGaps: "No PT",
    penaltyRisk: "₹250 Cr",
    automation: "Low",
  },

  {
    controlId: "DPDPA-BRH-01",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Notify DPBI of breach",
    implementationStandard:
      "Notify Data Protection Board in prescribed manner/timeline",
    evidence: "Notification procedure",
    owner: "DPO",
    frequency: "Per breach",
    technologyEnablers: "Incident Mgmt, SOAR",
    auditMethod: "Notification drill",
    commonGaps: "No procedure",
    penaltyRisk: "₹250 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-BRH-02",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Notify Data Principal",
    implementationStandard:
      "Notify affected individuals in prescribed manner",
    evidence: "Templates, Channels",
    owner: "DPO",
    frequency: "Per breach",
    technologyEnablers: "Mass Notification",
    auditMethod: "Template review",
    commonGaps: "No notification",
    penaltyRisk: "₹250 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-BRH-03",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Breach detection capability",
    implementationStandard:
      "Technical measures to detect breaches promptly",
    evidence: "Detection architecture",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "SIEM, DLP, UEBA",
    auditMethod: "Detection testing",
    commonGaps: "Slow detection",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-BRH-04",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Breach response plan",
    implementationStandard:
      "Documented plan covering detection, containment, notification",
    evidence: "Breach response plan",
    owner: "DPO/CISO",
    frequency: "Annual",
    technologyEnablers: "Incident Management",
    auditMethod: "Plan walkthrough",
    commonGaps: "No plan",
    penaltyRisk: "₹50 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-BRH-05",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Breach impact assessment",
    implementationStandard:
      "Assess impact including affected individuals, data types",
    evidence: "Impact template",
    owner: "DPO",
    frequency: "Per breach",
    technologyEnablers: "Incident Management",
    auditMethod: "Assessment review",
    commonGaps: "No assessment",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-BRH-06",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Breach register",
    implementationStandard:
      "Register of all breaches with details and actions",
    evidence: "Breach register",
    owner: "DPO",
    frequency: "Per breach",
    technologyEnablers: "Incident Mgmt, GRC",
    auditMethod: "Register review",
    commonGaps: "No register",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-BRH-07",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Post-breach remediation",
    implementationStandard:
      "Remediation to prevent recurrence",
    evidence: "Remediation plan",
    owner: "CISO/DPO",
    frequency: "Per breach",
    technologyEnablers: "Incident Management",
    auditMethod: "Remediation tracking",
    commonGaps: "No remediation",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-BRH-08",
    domain: "Breach Mgmt",
    dpdpaSection: "S.8(6)",
    controlRequirement: "Breach notification content",
    implementationStandard:
      "Include nature, data involved, consequences, remedial measures",
    evidence: "Templates, Checklist",
    owner: "DPO",
    frequency: "Per breach",
    technologyEnablers: "Incident Management",
    auditMethod: "Checklist review",
    commonGaps: "Incomplete notification",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },

  {
    controlId: "DPDPA-CHD-01",
    domain: "Children's Data",
    dpdpaSection: "S.9(1)",
    controlRequirement: "Verifiable parental consent",
    implementationStandard:
      "Obtain verifiable parent/guardian consent before processing",
    evidence: "Parental consent mechanism",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Age Verification, Consent",
    auditMethod: "Consent verification testing",
    commonGaps: "No verification",
    penaltyRisk: "₹200 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CHD-02",
    domain: "Children's Data",
    dpdpaSection: "S.9(2)",
    controlRequirement: "No tracking/behavioral monitoring",
    implementationStandard:
      "Do not track, monitor, or target advertising at children",
    evidence: "Technical controls",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Consent Platform, AdTech",
    auditMethod: "Tag/audience audit",
    commonGaps: "Tracking active",
    penaltyRisk: "₹200 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CHD-03",
    domain: "Children's Data",
    dpdpaSection: "S.9(2)",
    controlRequirement: "No detrimental processing",
    implementationStandard:
      "Do not process in way detrimental to child's well-being",
    evidence: "Processing review",
    owner: "DPO",
    frequency: "Per processing",
    technologyEnablers: "Privacy Management",
    auditMethod: "Review records",
    commonGaps: "No assessment",
    penaltyRisk: "₹200 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-CHD-04",
    domain: "Children's Data",
    dpdpaSection: "S.9",
    controlRequirement: "Age verification mechanism",
    implementationStandard:
      "Reliable age verification before collection",
    evidence: "Age gate UI",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Yoti, Jumio",
    auditMethod: "Age-gate testing",
    commonGaps: "Self-declaration only",
    penaltyRisk: "₹200 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CHD-05",
    domain: "Children's Data",
    dpdpaSection: "S.9",
    controlRequirement: "Child definition compliance",
    implementationStandard:
      "Apply protections to individuals below 18",
    evidence: "Age threshold config",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Age Verification",
    auditMethod: "Config review",
    commonGaps: "Wrong threshold",
    penaltyRisk: "₹200 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CHD-06",
    domain: "Children's Data",
    dpdpaSection: "S.9",
    controlRequirement: "Guardian verification",
    implementationStandard:
      "Verify person giving consent is actual parent/guardian",
    evidence: "Verification process",
    owner: "DPO",
    frequency: "Per consent",
    technologyEnablers: "Identity Verification",
    auditMethod: "Process test",
    commonGaps: "No verification",
    penaltyRisk: "₹200 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CHD-07",
    domain: "Children's Data",
    dpdpaSection: "S.9",
    controlRequirement: "Enhanced minimization for children",
    implementationStandard:
      "Collect absolute minimum from children",
    evidence: "Children's data inventory",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Data Discovery",
    auditMethod: "Inventory review",
    commonGaps: "Excessive child data",
    penaltyRisk: "₹200 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CHD-08",
    domain: "Children's Data",
    dpdpaSection: "S.9",
    controlRequirement: "Persons with disabilities",
    implementationStandard:
      "Apply similar protections with lawful guardian consent",
    evidence: "Disability accommodation",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Consent Platform",
    auditMethod: "Process review",
    commonGaps: "No provisions",
    penaltyRisk: "₹200 Cr",
    automation: "Medium",
  },

  {
    controlId: "DPDPA-CBT-01",
    domain: "Cross-Border",
    dpdpaSection: "S.16(1)",
    controlRequirement: "Transfer to notified countries only",
    implementationStandard:
      "Transfer only to government-notified countries",
    evidence: "Country whitelist, Logs",
    owner: "DPO",
    frequency: "Per transfer",
    technologyEnablers: "Data Flow Mapping",
    auditMethod: "Transfer audit",
    commonGaps: "Non-notified transfers",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CBT-02",
    domain: "Cross-Border",
    dpdpaSection: "S.16",
    controlRequirement: "Data flow mapping",
    implementationStandard:
      "Map all cross-border flows with destination, recipient, purpose",
    evidence: "Flow inventory",
    owner: "DPO",
    frequency: "Quarterly",
    technologyEnablers: "Data Discovery, Flow Mapping",
    auditMethod: "Inventory review",
    commonGaps: "Unmapped transfers",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CBT-03",
    domain: "Cross-Border",
    dpdpaSection: "S.16",
    controlRequirement: "Contractual safeguards",
    implementationStandard:
      "Clauses ensuring recipient provides equivalent protection",
    evidence: "Transfer agreements",
    owner: "Legal/DPO",
    frequency: "Per transfer",
    technologyEnablers: "Contract Management",
    auditMethod: "Contract review",
    commonGaps: "No protection",
    penaltyRisk: "₹250 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-CBT-04",
    domain: "Cross-Border",
    dpdpaSection: "S.16",
    controlRequirement: "Transfer impact assessment",
    implementationStandard:
      "Assess risks of transferring to specific country/recipient",
    evidence: "Risk assessment",
    owner: "DPO",
    frequency: "Per new transfer",
    technologyEnablers: "Privacy Management",
    auditMethod: "Assessment review",
    commonGaps: "No assessment",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-CBT-05",
    domain: "Cross-Border",
    dpdpaSection: "S.5",
    controlRequirement: "Inform of transfers",
    implementationStandard:
      "Include transfer details in privacy notice",
    evidence: "Notice with transfer info",
    owner: "DPO",
    frequency: "Per collection",
    technologyEnablers: "Consent Platform",
    auditMethod: "Notice review",
    commonGaps: "No disclosure",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CBT-06",
    domain: "Cross-Border",
    dpdpaSection: "S.16",
    controlRequirement: "Transfer logging",
    implementationStandard:
      "Log all cross-border transfers with audit trail",
    evidence: "Transfer logs",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "DLP, Flow Monitoring",
    auditMethod: "Log review",
    commonGaps: "No logging",
    penaltyRisk: "₹50 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-CBT-07",
    domain: "Cross-Border",
    dpdpaSection: "S.16",
    controlRequirement: "Government restriction compliance",
    implementationStandard:
      "Comply with additional government-imposed restrictions",
    evidence: "Restriction monitoring",
    owner: "Legal/DPO",
    frequency: "Continuous",
    technologyEnablers: "Regulatory Intelligence",
    auditMethod: "Monitoring review",
    commonGaps: "Non-compliance",
    penaltyRisk: "₹250 Cr",
    automation: "Low",
  },

  {
    controlId: "DPDPA-SDF-01",
    domain: "Significant DF",
    dpdpaSection: "S.10(2)(a)",
    controlRequirement: "Appoint DPO",
    implementationStandard:
      "Appoint DPO based in India as contact point",
    evidence: "Appointment letter",
    owner: "Board/MD",
    frequency: "Ongoing",
    technologyEnablers: "-",
    auditMethod: "Org review",
    commonGaps: "No DPO; Not in India",
    penaltyRisk: "₹150 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-SDF-02",
    domain: "Significant DF",
    dpdpaSection: "S.10(2)(b)",
    controlRequirement: "Appoint Independent Auditor",
    implementationStandard:
      "Appoint independent auditor for data audit",
    evidence: "Auditor engagement",
    owner: "Board/DPO",
    frequency: "Annual",
    technologyEnablers: "-",
    auditMethod: "Engagement verification",
    commonGaps: "No auditor",
    penaltyRisk: "₹150 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-SDF-03",
    domain: "Significant DF",
    dpdpaSection: "S.10(2)(c)",
    controlRequirement: "Conduct DPIA",
    implementationStandard:
      "DPIA for high-risk processing before implementation",
    evidence: "DPIA methodology, Reports",
    owner: "DPO",
    frequency: "Per activity",
    technologyEnablers: "OneTrust, TrustArc",
    auditMethod: "DPIA review",
    commonGaps: "No DPIA",
    penaltyRisk: "₹150 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-SDF-04",
    domain: "Significant DF",
    dpdpaSection: "S.10(2)",
    controlRequirement: "Periodic data audit",
    implementationStandard:
      "Periodic audit by independent auditor",
    evidence: "Audit reports",
    owner: "DPO",
    frequency: "Annual",
    technologyEnablers: "GRC Platform",
    auditMethod: "Report review",
    commonGaps: "No audit",
    penaltyRisk: "₹150 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-SDF-05",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "DPO reporting to Board",
    implementationStandard: "DPO reports directly to Board",
    evidence: "Reporting schedule",
    owner: "DPO/Board",
    frequency: "Quarterly",
    technologyEnablers: "-",
    auditMethod: "Board pack review",
    commonGaps: "No Board reporting",
    penaltyRisk: "₹50 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-SDF-06",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "DPBI reporting",
    implementationStandard:
      "Submit periodic reports to DPBI",
    evidence: "Submitted reports",
    owner: "DPO",
    frequency: "As prescribed",
    technologyEnablers: "Regulatory Reporting",
    auditMethod: "Submission verification",
    commonGaps: "Missing reports",
    penaltyRisk: "₹150 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-SDF-07",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "SDF notification compliance",
    implementationStandard:
      "Comply with additional SDF notifications",
    evidence: "Compliance tracking",
    owner: "Legal/DPO",
    frequency: "Continuous",
    technologyEnablers: "Regulatory Intelligence",
    auditMethod: "Tracking review",
    commonGaps: "Non-compliance",
    penaltyRisk: "₹150 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-SDF-08",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "Algorithmic transparency",
    implementationStandard:
      "Provide transparency about algorithmic decisions (if notified)",
    evidence: "Algorithm documentation",
    owner: "DPO/Tech",
    frequency: "Per algorithm",
    technologyEnablers: "AI Governance",
    auditMethod: "Documentation review",
    commonGaps: "No transparency",
    penaltyRisk: "₹150 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-SDF-09",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "Enhanced security",
    implementationStandard:
      "Enhanced security proportionate to risk",
    evidence: "Enhanced architecture",
    owner: "CISO",
    frequency: "Continuous",
    technologyEnablers: "Advanced security",
    auditMethod: "Architecture review",
    commonGaps: "Standard only",
    penaltyRisk: "₹250 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-SDF-10",
    domain: "Significant DF",
    dpdpaSection: "S.10",
    controlRequirement: "SDF status assessment",
    implementationStandard:
      "Assess SDF criteria and notify DPBI",
    evidence: "Assessment, Notification",
    owner: "Legal/DPO",
    frequency: "Annual",
    technologyEnablers: "-",
    auditMethod: "Assessment review",
    commonGaps: "No self-assessment",
    penaltyRisk: "₹50 Cr",
    automation: "Low",
  },

  {
    controlId: "DPDPA-VPM-01",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8(2)",
    controlRequirement: "Data processing agreement",
    implementationStandard:
      "Written contract specifying instructions, security, compliance",
    evidence: "DPA templates, Agreements",
    owner: "Legal/DPO",
    frequency: "Per engagement",
    technologyEnablers: "Contract Management",
    auditMethod: "Contract sampling",
    commonGaps: "No DPA",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-VPM-02",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8(2)",
    controlRequirement: "Processor security requirements",
    implementationStandard:
      "Contractually require reasonable security",
    evidence: "Security requirements",
    owner: "DPO",
    frequency: "Per engagement",
    technologyEnablers: "Vendor Risk Mgmt",
    auditMethod: "Clause review",
    commonGaps: "No requirements",
    penaltyRisk: "₹250 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-VPM-03",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8(2)",
    controlRequirement: "Sub-processor controls",
    implementationStandard:
      "Require notification/approval; flow-down obligations",
    evidence: "Sub-processor clause",
    owner: "DPO",
    frequency: "Per sub-processor",
    technologyEnablers: "Vendor Risk Mgmt",
    auditMethod: "Contract review",
    commonGaps: "No visibility",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-VPM-04",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8(2)",
    controlRequirement: "Processor breach notification",
    implementationStandard:
      "Require breach notification without delay",
    evidence: "Notification clause",
    owner: "DPO",
    frequency: "Per engagement",
    technologyEnablers: "Incident Management",
    auditMethod: "Clause review",
    commonGaps: "No clause",
    penaltyRisk: "₹250 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-VPM-05",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8",
    controlRequirement: "Processor audit rights",
    implementationStandard: "Contractual audit rights",
    evidence: "Audit clause, Reports",
    owner: "DPO",
    frequency: "Annual",
    technologyEnablers: "Vendor Risk Mgmt",
    auditMethod: "Audit review",
    commonGaps: "No audit rights",
    penaltyRisk: "₹50 Cr",
    automation: "Low",
  },
  {
    controlId: "DPDPA-VPM-06",
    domain: "Vendor/Processor",
    dpdpaSection: "S.8(2)",
    controlRequirement: "Data return/deletion",
    implementationStandard:
      "Require return/deletion upon termination",
    evidence: "Offboarding clause",
    owner: "DPO",
    frequency: "Per termination",
    technologyEnablers: "Vendor Risk Mgmt",
    auditMethod: "Offboarding review",
    commonGaps: "No deletion req",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },

  {
    controlId: "DPDPA-ACC-01",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Demonstrate compliance",
    implementationStandard:
      "Ability to demonstrate compliance upon request",
    evidence: "Compliance documentation",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Privacy Mgmt, GRC",
    auditMethod: "Evidence review",
    commonGaps: "No evidence",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-ACC-02",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Privacy governance framework",
    implementationStandard:
      "Documented framework with policies, procedures, controls",
    evidence: "Framework, Policy library",
    owner: "DPO",
    frequency: "Annual",
    technologyEnablers: "Policy Management",
    auditMethod: "Framework review",
    commonGaps: "No framework",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-ACC-03",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Privacy training",
    implementationStandard:
      "Regular training for employees handling personal data",
    evidence: "Curriculum, Records",
    owner: "DPO/HR",
    frequency: "Annual",
    technologyEnablers: "LMS",
    auditMethod: "Training record review",
    commonGaps: "No training",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-ACC-04",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Internal privacy audit",
    implementationStandard:
      "Regular internal audits of compliance",
    evidence: "Audit plan, Reports",
    owner: "DPO/Audit",
    frequency: "Annual",
    technologyEnablers: "GRC Platform",
    auditMethod: "Audit evidence review",
    commonGaps: "No audits",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-ACC-05",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Compliance metrics",
    implementationStandard:
      "Track and report privacy metrics to management",
    evidence: "Metrics dashboard",
    owner: "DPO",
    frequency: "Quarterly",
    technologyEnablers: "Privacy Mgmt, BI",
    auditMethod: "Dashboard review",
    commonGaps: "No metrics",
    penaltyRisk: "₹10 Cr",
    automation: "High",
  },
  {
    controlId: "DPDPA-ACC-06",
    domain: "Accountability",
    dpdpaSection: "S.8",
    controlRequirement: "Privacy by design",
    implementationStandard:
      "Embed privacy in design of systems and processes",
    evidence: "PbD methodology",
    owner: "DPO",
    frequency: "Per project",
    technologyEnablers: "Privacy Management",
    auditMethod: "Project sampling",
    commonGaps: "Afterthought",
    penaltyRisk: "₹50 Cr",
    automation: "Medium",
  },
  {
    controlId: "DPDPA-ACC-07",
    domain: "Accountability",
    dpdpaSection: "S.30",
    controlRequirement: "Cooperation with DPBI",
    implementationStandard:
      "Cooperate with inquiries, provide information",
    evidence: "Response process",
    owner: "DPO/Legal",
    frequency: "Per inquiry",
    technologyEnablers: "Case Management",
    auditMethod: "Inquiry response review",
    commonGaps: "Delayed cooperation",
    penaltyRisk: "₹150 Cr",
    automation: "Low",
  },
];

export const DPDPA_PENALTY_TIERS = [
  {
    tier: "Tier 1",
    maxPenalty: "₹250 Crore",
    keyViolations:
      "Personal data breach; Cross-border violations; SDF non-compliance",
  },
  {
    tier: "Tier 2",
    maxPenalty: "₹200 Crore",
    keyViolations: "Children's data violations",
  },
  {
    tier: "Tier 3",
    maxPenalty: "₹150 Crore",
    keyViolations:
      "SDF obligations (DPO, auditor, DPIA); DPBI non-cooperation",
  },
  {
    tier: "Tier 4",
    maxPenalty: "₹50 Crore",
    keyViolations: "Consent violations; Purpose limitation; Rights denial",
  },
  {
    tier: "Tier 5",
    maxPenalty: "₹10,000",
    keyViolations: "Data Principal false information",
  },
];

export const DPDPA_CROSSMAP = [
  { dpdpaControl: "DPDPA-CON-01", rbiMapping: "-", sebiMapping: "-", iso27701: "7.2.3", gdprArticle: "Art. 7" },
  { dpdpaControl: "DPDPA-DPR-01", rbiMapping: "-", sebiMapping: "-", iso27701: "7.3.2", gdprArticle: "Art. 15" },
  { dpdpaControl: "DPDPA-DPR-03", rbiMapping: "-", sebiMapping: "-", iso27701: "7.3.6", gdprArticle: "Art. 17" },
  { dpdpaControl: "DPDPA-SEC-01", rbiMapping: "RBI-SEC-01", sebiMapping: "CSCRF-SEC-01", iso27701: "6.9", gdprArticle: "Art. 32" },
  { dpdpaControl: "DPDPA-SEC-02", rbiMapping: "RBI-DAT-02", sebiMapping: "CSCRF-DATA-01", iso27701: "6.9.3", gdprArticle: "Art. 32" },
  { dpdpaControl: "DPDPA-BRH-01", rbiMapping: "RBI-INC-03", sebiMapping: "CSCRF-INC-02", iso27701: "6.13", gdprArticle: "Art. 33" },
  { dpdpaControl: "DPDPA-CBT-01", rbiMapping: "RBI-DAT-10", sebiMapping: "-", iso27701: "7.5", gdprArticle: "Art. 44-49" },
  { dpdpaControl: "DPDPA-VPM-01", rbiMapping: "RBI-TPR-03", sebiMapping: "CSCRF-TPR-01", iso27701: "6.12", gdprArticle: "Art. 28" },
];
